<template>
  <div class="sealmanage">
    <!-- 头部banner -->
    <BannerForm
      :pcBgImg="pcBgImg"
      :landingPageName="landingPageName"
      :showForm="!showScrollForm"
      :logoSrc="logoSrc"
      title="免费试用"
      setHeight="540"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
    >
      <template slot="title">
        <div class="sealmanage-title-content">
          <div class="one-line">合法可靠</div>
          <div class="two-line">一站式签章管理平台</div>
        </div>
      </template>
      <template slot="desc">
        <div class="sealmanage-desc">浙江省“最多跑一次”电子签指定供应商</div>
      </template>
    </BannerForm>
    <!-- banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- 二屏 解决传统印章管控难题 -->
    <div class="screen-two">
      <SectionCard :isPcFlag="true" title="解决传统印章管控难题">
        <img src="@/assets/images/landing-semsign/second-picture.png" alt="" />
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="onlineConsultation">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 三屏 方案1：智能硬件管控物理印章 -->
    <div class="screen-three">
      <SectionCard :isPcFlag="true" title="方案1：智能硬件管控物理印章" bgColor="#F6F7F9" :bgImg="screenThreeBgImg">
        <div class="scenarios-content">
          <ul class="tab_title">
            <li v-for="(v, i) in applicationScenariosList" :class="m == i ? 'active' : ''" @click="m = i" :key="i.title">
              {{ v.title }}
            </li>
          </ul>

          <!-- 内容 -->
          <div class="tab_content">
            <div class="content-item" v-for="(v, i) in applicationScenariosList" v-show="m == i" :key="i">
              <div class="desc">
                <span class="desc-one">{{ v.descOne }}</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="desc-two">{{ v.descTwo }}</span>
              </div>
              <img class="img" :src="v.img" alt="" />
            </div>
          </div>

          <!-- 底部描述 -->
          <div class="footer-desc">
            <p v-for="(item, index) in applicationScenariosList" v-show="m == index" :key="index">{{ item.footerDesc }}</p>
          </div>
        </div>

        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="onlineConsultation">在线咨询</div>
          </div>
        </div>

        <!-- 用印过程 -->
        <div class="process-printing">
          <div class="title">用印过程</div>
          <div class="process-img">
            <img src="@/assets/images/landing-semsign/yygc.png" alt="" />
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 四屏 方案2：电子签章取代物理印章 -->
    <div class="screen-four">
      <SectionCard :isPcFlag="true" title="方案2：电子签章取代物理印章">
        <div class="desc">全程线上化，签管更简单</div>
        <img src="@/assets/images/landing-semsign/second-screen.png" alt="" />
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="onlineConsultation">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 五屏 电子签章应用场景 -->
    <div class="screen-five">
      <SolutionList
        class="application-scenarios"
        :solutionList="solutionInfo.solutionList"
        :btnList="solutionInfo.btnList"
        :title="solutionInfo.title"
      ></SolutionList>
    </div>
    <!-- 六屏 一站式签章管理平台 -->
    <div class="screen-six">
      <Power class="one-stop-shop" :powerList="powerInfo.powerList" :title="powerInfo.title" :btnList="powerInfo.btnList"></Power>
    </div>
    <!-- 七屏 客户案例 -->
    <div class="screen-seven">
      <OrgList class="customer-cases" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    </div>
    <!-- 八屏 关于e签宝 -->
    <div class="screen-eight">
      <SectionCard bgColor="#fbfcfd" :isPcFlag="true" title="关于e签宝">
        <div class="content">
          <div class="left">
            <img class="cover-picture" src="@/assets/images/landing-semsign/cover-picture.png" alt="" />
          </div>
          <div class="right">
            <div class="line"></div>
            <div class="text">
              <div class="text-item" v-for="item in eQianBao" :key="item.key">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 底部小象留资条 -->
    <ScrollForm
      :show="showScrollForm"
      :landingPageName="landingPageName"
      title="企业用户免费试用"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
    />
    <!-- 底部备案信息 -->
    <FooterBasis />
    <!-- 右侧客服  yinzhangright: 咨询来源：客服-->
    <Contact :landingPageName="landingPageName" newCustomerServiceLink="sealmanage" />

    <!-- 免费试用申请弹框 -->
    <UseDialog ref="dialog" />
    <!-- 提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交完成弹框 -->
    <SuccessFrom v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu'
export default {
  name: 'sealmanage',
  mixins: [qiyuMixin],
  components: {
    BannerForm: () => import('@/components/BannerForm.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    SuccessFrom: () => import('@/views/extension/components/pc/successFrom.vue'),
    SolutionList: () => import('@/views/mixOs/components/pc/SolutionList.vue'),
    Power: () => import('@/views/mixOs/components/pc/Power.vue'),
    OrgList: () => import('@/views/extension/components/pc/OrgList.vue'),
    ScrollForm: () => import('@/views/extension/components/pc/ScrollForm.vue'),
    FooterBasis: () => import('@/components/FooterBasis.vue'),
    Contact: () => import('@/components/Contact.vue'),
  },
  data() {
    return {
      m: 0,
      logoSrc: require('@/assets/images/real-estate/logo.png'),
      pcBgImg: require('@/assets/images/landing-semsign/banner-bg.png'),
      screenThreeBgImg: require('@/assets/images/landing-semsign/third-bg-img.png'),
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      showScrollForm: false,
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      dialogVideoVisible: false,
      showSuccessDialog: false,

      bannerBottomData: dataList.bannerBottomData,
      applicationScenariosList: dataList.applicationScenariosList,
      solutionInfo: dataList.solutionInfo,
      powerInfo: dataList.powerInfo,
      orgList: dataList.orgList,
      eQianBao: dataList.eQianBao,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
    onlineConsultation() {
      window.open(
        'https://p.qiao.baidu.com/cps/chat?siteId=18635174&userId=43265381&siteToken=071de2cef6ae08e8c0f605780799fd7a&cp=&cr=&cw=%E7%BD%91%E9%A1%B5%E4%B8%AD',
        'kefuWindow',
        'height=631,width=842,top=50'
      )
    },
  },
}
</script>

<style lang="less" scoped>
@import './style.less';
</style>
